import React from "react";

const DaysTab = ({ activeDay, onDayChange }) => {
  return (
    <ul className="nav nav-tabs" id="myTab" role="tablist">
      {[...Array(7)].map((_, index) => (
        <li className="nav-item" role="presentation" key={index}>
          <button
            className={`nav-link ${activeDay === `inner-${index + 1}` ? "active" : ""}`}
            id={`inner-${index + 1}-tab`}
            data-bs-toggle="tab"
            data-bs-target={`#inner-${index + 1}`}
            type="button"
            role="tab"
            aria-controls={`inner-${index + 1}`}
            aria-selected={activeDay === `inner-${index + 1}`}
            onClick={() => onDayChange(`inner-${index + 1}`)}
          >
            Day {index + 1}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default DaysTab;
